import { PotentialPolicyState } from '../types/PolicySliceState';

export const policySliceInitialState: PotentialPolicyState = {
  createPolicyOptions: {
    claimIdList: [],
  },
  statuses: {
    isCreatePotentialPolicyLoading: false,
    isGetPotentialPolicyLoading: false,
    isClaimOptionsLoading: false,
  },
  claimOptions: [],
  data: {
    listings: [],
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 20,
    },
  },
  savedFiltersForSending: null,
  savedSortingForSending: null,
};
